import { pubSub } from '@utils/PubSub';
import Slider from '@utils/slider';
import {
  spotlightModuleCard,
  spotlightModuleHeader,
} from '@utils/ModuleResources';
import Hotspots from '@modules/Hotspots';
import { initCustomLinebreaks } from '@utils/breakpoints';
import VideoControls from '@utils/videoControls';

export default class SpotlightModule {
  constructor(context) {
    this.moduleId = context.getAttribute('id');
    this.headlineContainer = context.querySelector('.spotlight__header');
    this.headline = context.querySelector('.header__headline');
    this.cardContainer = context.querySelector('.splide__list');
    this.sliderContainer = context.querySelector('.js-splide-slider');
    this.splideContainer = context.querySelector('.splide');
    this.sectionContainer = context.parentElement;

    pubSub.subscribe(`dy:spotlight:${this.moduleId}:init`, () => {
      this.initEvent();
    });
    pubSub.unsubscribe(`dy:spotlight:${this.moduleId}:init`, this.initEvent);
    //timeout
    setTimeout(() => {
      this.splideContainer.classList.add('content--loaded');
      this.initVideoControls(context);
    }, 500);

    if (context.querySelector('[data-props-hotspot]')) {
      //set splide container to overflow visible for the popup
      context
        .querySelector('.spotlight__cards')
        .classList.add('overflow-visible');
      //initialize individual hotspots
      context.querySelectorAll('[data-props-hotspot]')?.forEach((tileImage) => {
        const hotspotJSON = tileImage.getAttribute('data-props-hotspot');
        tileImage.parentNode.classList.add('overflow-visible');
        new Hotspots(tileImage, JSON.parse(hotspotJSON));
      });
    }
  }
  initEvent() {
    this.updateFromDY(window.Brooklinen.spotlight);
  }

  initVideoControls(context) {
    if (context.querySelector('.js--video-controls')) {
      context.querySelectorAll('.js--video-controls').forEach((controls) => {
        new VideoControls(controls, controls.parentElement);
      });
    }
  }

  updateFromDY(data) {
    const module_data = data.filter(
      (data) => data.general.module_id == this.moduleId
    )[0];
    this.updateModuleSettings(module_data);
  }

  updateModuleSettings(data) {
    //update bg color
    this.sectionContainer.style.backgroundColor = data.general.background_color;
    //update headline
    this.headlineContainer.innerHTML = initCustomLinebreaks(
      spotlightModuleHeader(data)
    );

    //determine how many cards to loop through, then set slider container's data attributes accordingly
    const cards = data.cards.filter((card) => card.image.enable == true);
    this.splideContainer.setAttribute('data-block-count', cards.length);
    if (cards.length > 4)
      this.splideContainer.setAttribute('data-five-up', true);

    //populate slider with card content from DY
    this.cardContainer.innerHTML = '';
    cards.forEach((card, i) => {
      this.cardContainer.innerHTML += spotlightModuleCard(card, i);
    });
    new Slider(this.sliderContainer);
    this.splideContainer.classList.add('content--loaded');
  }
}
